/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MatchWithBetSchema } from '../models/MatchWithBetSchema';
import type { MatchWithBetsSchema } from '../models/MatchWithBetsSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MatchesService {

    /**
     * List Matches With Bet
     * @returns MatchWithBetSchema OK
     * @throws ApiError
     */
    public static listMatchesWithBet(): CancelablePromise<Array<MatchWithBetSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/matches/bets/',
        });
    }

    /**
     * Get Match
     * @param matchId
     * @returns MatchWithBetsSchema OK
     * @throws ApiError
     */
    public static getMatch(
        matchId: number,
    ): CancelablePromise<MatchWithBetsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/matches/{match_id}',
            path: {
                'match_id': matchId,
            },
        });
    }

    /**
     * Get Match Next
     * Ближайший матч, который ещё не начался, или текущий LIVE.
     * Если есть LIVE — возвращает его.
     * Если нет — ближайший по scheduled_at.
     * @returns MatchWithBetSchema OK
     * @throws ApiError
     */
    public static getMatchNext(): CancelablePromise<MatchWithBetSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/matches/next/',
        });
    }

    /**
     * Recent Matches
     * Последние завершённые матчи за 24 часа.
     * @returns MatchWithBetsSchema OK
     * @throws ApiError
     */
    public static recentMatches(): CancelablePromise<Array<MatchWithBetsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/matches/recent',
        });
    }

}
